<template>
  <v-card color="grey-lighten-4" class="rounded pa-6 elevation-0">
    <v-form
        :model-value="valid"
        ref="payment_form"
        @update:model-value="$emit('update:valid', $event)"
    >
      <v-row>
        <v-col>
          <p class="text-h6">Transaction management</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-1">
          <v-select
              :items="typeOptions"
              :model-value="type"
              :rules="typeRules"
              label="Select type"
              bg-color="grey-lighten-5"
              @update:model-value="$emit('update:type', $event)"
          />
        </v-col>
        <v-col cols="12" md="8" class="py-1">
          <v-text-field
              :model-value="amount"
              :clearable="true"
              :rules="amountRules"
              label="Amount"
              variant="outlined"
              type="number"
              @update:model-value="$emit('update:amount', $event)"
          />
        </v-col>
        <v-col cols="12" md="4" class="py-1">
          <v-select
              :items="currencyOptions"
              :model-value="currency"
              :rules="currencyRules"
              label="Select currency"
              bg-color="grey-lighten-5"
              @update:model-value="$emit('update:currency', $event)"
          />
        </v-col>
        <v-col cols="12" class="pb-0 pt-1">
          <v-text-field
              :model-value="description"
              :clearable="true"
              label="Description"
              variant="outlined"
              @update:model-value="$emit('update:description', $event)"
          />
        </v-col>
        <v-col class="pt-2 pb-4">
          <v-row
              justify="end"
              class="px-3"
          >
            <v-btn
                :block="$vuetify.display.smAndDown"
                color="success"
                @click="submit"
            >
              Create
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-overlay
          :model-value="loading"
          :persistent="loading"
          :contained="true"
          class="align-center justify-center"
      >
        <v-progress-circular
            indeterminate
            size="64"
        />
      </v-overlay>
    </v-form>
  </v-card>
</template>

<script>

export default {
  name: "AccountantCard",
  emits: ['update:type', 'update:amount', 'update:currency', 'update:description', 'update:valid'],
  props: {
    typeOptions: Array,
    currencyOptions: Array,

    valid: Boolean,
    type: String,
    amount: Number,
    currency: String,
    description: Number,
    saveCallback: Function,
    loading: Boolean,
  },
  data() {
    return {
      typeRules: [
        v => !!v || 'Type must be selected',
      ],
      currencyRules: [
        v => !!v || 'Currency must be selected',
      ],
      amountRules: [
        v => !!v || 'Amount is required',
        v => v > 0 || 'Amount must be positive',
      ]
    }
  },
  methods: {
    submit() {
      this.$refs.payment_form.validate()
      this.saveCallback()
    }
  }
}
</script>

<style scoped>

</style>